import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./TechnologyModal.css";
import InputField from "./InputFields/InputField";
import OtpInput from "react-otp-input";
import { NotificationManager } from "react-notifications";
// import cookie from "react-cookie";
import MainService from "../../common/MainService";

export default function TechnologyModal(props) {



  const [fieldValue, setFieldValue] = useState({
    company: "",
    name: "",
    phone: "",
    email: "",
    role: "",
    requesttype: "lead",
    leadType: "Demo",
    parentid: "GBR-Admin-Realm2"
  });

  const clickCount = 0;
  const [OTPBtnDisabled, setOTPBtnDisabled] = useState(true);

  // const [role, setRole] = useState([]);
  const [validations, setValidations] = useState({
    company: "",
    name: "",
    phone: "",
    email: "",
  });

  const [otpView, setOtpView] = useState(false);
  const [OTP, setOTP] = useState();
  const handleChange = (OTP) => setOTP(OTP);

  const otpVal = { phone: fieldValue.phone, otp: OTP, email:fieldValue.email };

  const validateAll = () => {
    const { company, name, email, phone, role } = fieldValue;
    const validations = {
      company: "",
      name: "",
      email: "",
      phone: "",
      role: "",
    };
    let isValid = true;

    if (!company) {
      validations.company = "Company Name is required";
      isValid = false;
    }

    if (!name) {
      validations.name = " Name is required";
      isValid = false;
    }

    if (!role) {
      validations.role = "Please select the role";
      isValid = false;
    }
    // if (name && name.length < 3 || name.length > 50) {
    //   validations.name = 'Name must contain between 3 and 50 characters'
    //   isValid = false
    // }

    if (!email) {
      validations.email = "Email is required";
      isValid = false;
    }

    if (email && !/\S+@\S+\.\S+/.test(email)) {
      validations.email = "Email format must be as example@mail.com";
      isValid = false;
    }

    if (!phone) {
      validations.phone = "Phone number is required";
      isValid = false;
    }

    if (!isValid) {
      setValidations(validations);
    }

    return isValid;
  };

  const validateOne = (e) => {
    const { name } = e.target;
    const value = fieldValue[name];
    let message = "";

    // if (!value) {
    //   message = `${name} is required`;
    // }
    if (!value && name === "company") {
      message = `Company name is required`;
    }
    if (!value && name === "name") {
      message = `Name is required`;
    }
    if (!value && name === "phone") {
      message = `Phone number is required`;
    }
    if (!value && name === "role") {
      message = `Please select the role`;
    }

    if (value && name === "email" && !/\S+@\S+\.\S+/.test(value)) {
      message = "Please enter a valid email";
    }

    setValidations({ ...validations, [name]: message });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFieldValue((prevProps) => ({
      ...prevProps,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = validateAll();
  
    if (!isValid) {
      return false;
    }
  
    timerFunction();
    const fieldValueStringify = JSON.stringify(fieldValue);
    const url = `${window.appConfig.getOtp}${window.appConfig.TokenRelam}/otp/register/${window.appConfig.clientId}/${window.appConfig.clientSecret}`;
    fetch(url, {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
      },
      body: fieldValueStringify,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.text();
      })
      .then((result) => {
       
          setOtpView(true);
          return NotificationManager.success(result);
      })
      .catch((err) => {
        console.error("Error:", err);
        NotificationManager.error(
          "Something went wrong! Please try again later.",
          "Error"
        );
      });
  };
  // const otpSubmitHandler = (e) => {
  //   e.preventDefault();

  //   const fieldValueStringifyOTP = JSON.stringify(otpVal);
  //   console.log(
  //     fieldValueStringifyOTP,
  //     "fieldValueStringify fieldValueStringify"
  //   );
  //   fetch(
  //     // `http://35.92.73.23:3333/validateOtp`,
  //     `${window.appConfig.validateOtp}`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "*/*",
  //         "Content-Type": "application/json",
  //       },
  //       body: fieldValueStringifyOTP,
  //     }
  //   )
  //     .then((res) => res.text())
  //     .then((result) => {
  //       if (result === "Lead Created") {
  //         window.location.replace(props.href);
  //       } else {
  //         return NotificationManager.success(result);
  //       }
  //     })
  //     .catch((err) => console.log("err", err));
  // };


  const otpSubmitHandler = (e) => {
    e.preventDefault();
  
    const fieldValueStringifyOTP = JSON.stringify(otpVal);
  
    const url = `${window.appConfig.validateOtp}${window.appConfig.TokenRelam}/${window.appConfig.clientId}/${window.appConfig.clientSecret}`;
  
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: fieldValueStringifyOTP,
    })
      .then((res) => res.text())
      .then((result) => {
        if (result === "OTP validated") {
          const _data = {
            source: fieldValue.email,
            destination: `${window.appConfig.TokenRelam}`,
            username: fieldValue.email,
            usertype: "",
            phone: fieldValue.phone,
            email: fieldValue.email,
            requesttype: "API",
            json: {
              company: fieldValue.company,
              name: fieldValue.name,
              phone: fieldValue.phone,
              email: fieldValue.email,
              enterpriseSize: fieldValue.role,
            },
          };
  
          return MainService.sendRequest(_data)
            .then(() => {
              NotificationManager.success("Request Sent. We will get back to you soon");
              window.location.replace(props.href);
            })
            .catch((err) => {
              NotificationManager.error(`MainService error: ${err}`);
            });
        } else {
          NotificationManager.error(result || "OTP validation failed");
        }
      })
      .catch((err) => NotificationManager.error(`OTP validation error: ${err}`));
  };
  
  // Resend OTP

  const mobileNumber = fieldValue.phone;

  const resendOTP = (e) => {
    e.preventDefault();

    fetch(
      `${window.appConfig.resendOTP}${mobileNumber}/${window.appConfig.TokenRelam}/${window.appConfig.clientId}/${window.appConfig.clientSecret}`,
      {
        method: "POST",
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: fieldValue.email }),
      }
    )
      .then((res) =>
        res.text().then((text) => {
          if (res.ok) {
            NotificationManager.success(text);
          } else {
            NotificationManager.error(text);
          }
        })
      )
      .catch((err) => console.log("err", err));
  };
  const renderInput = (inputProps, index) => (
    <input
      {...inputProps}
      type="text"
      maxLength="1"
      className="custom-otp-input"
      key={index}
    />
  );

  const timerFunction = () => {
    console.log("time start", clickCount);
    if (clickCount < 2) {
      const resendOTPTimer = setTimeout(() => {
        setOTPBtnDisabled(false);
      }, 60000 );

      return () => {
        clearTimeout(resendOTPTimer);
      };
    }
  };
  return (
    <div className="technologyModal">
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className="form-header">
          <Modal.Title id="contained-modal-title-vcenter">
            <h2 className="form-title mb-0 me-5">
              {!otpView
                ? "Please Fill the Form to View APIs"
                : "Please Enter OTP"}
            </h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!otpView ? (
            <form onSubmit={handleSubmit}>
              <div className="scrollableView">
                <div className="input-container mb-2">
                  <label className="d-block mb-1">Company Name*</label>
                  <InputField
                    type="text"
                    name="company"
                    value={fieldValue.company}
                    onChange={handleInputChange}
                    onBlur={validateOne}
                    placeholder="Please enter company name"
                    required="true"
                  />
                  <span className="d-block">{validations.company}</span>
                </div>

                <div className="input-container mb-2">
                  <label className="d-block mb-1"> Name*</label>
                  <InputField
                    type="text"
                    name="name"
                    value={fieldValue.name}
                    onChange={handleInputChange}
                    onBlur={validateOne}
                    required="true"
                    placeholder="Please enter your name"
                  />
                  <span className="d-block">{validations.name}</span>
                </div>

                <div className="input-container mb-2">
                  <label className="mb-1 d-block"> Phone Number*</label>
                  <InputField
                    type="phone"
                    name="phone"
                    value={fieldValue.phone}
                    onChange={handleInputChange}
                    onBlur={validateOne}
                    required="true"
                    placeholder="Please enter phone"
                  />
                  <span className="d-block">{validations.phone}</span>
                </div>
                <div className="input-container mb-2">
                  <label className="mb-1 d-block">Email*</label>
                  <InputField
                    type="email"
                    name="email"
                    value={fieldValue.email}
                    onChange={handleInputChange}
                    onBlur={validateOne}
                    required="true"
                    placeholder="Please enter email"
                  />
                  <span className="d-block">{validations.email}</span>
                </div>
                <div className="input-container mb-3">
                  <label className="mb-1 d-block">Role*</label>
                  <select
                    name="role"
                    value={fieldValue.role}
                    onChange={handleInputChange}
                    onBlur={validateOne}
                  >
                    <option value="" disabled selected hidden>
                      Role
                    </option>

                    <option value="CTO">CTO</option>
                    <option value="Director">Director</option>
                    <option selected value="Technical Manager">
                      Technical Manager
                    </option>
                    <option value="Architect">Architect</option>
                    <option value="Others">Others</option>
                  </select>
                  {validations.role && (
                    <span className="d-block">{validations.role}</span>
                  )}
                </div>
              </div>

              <button className="Formbutton" type="submit">
                Submit
              </button>
            </form>
          ) : (
            <form onSubmit={otpSubmitHandler} className="pe-5">
              <div className="input-container-mod">
                {/* <h2 className="container-heading2 mb-2"> Please enter OTP</h2> */}
                <div className="otp-container mb-2 ">
                  <OtpInput
                    value={OTP}
                    numInputs={6}
                    renderSeparator={<span>-</span>}
                    onChange={handleChange}
                    isInputNum={true}
                    renderInput={renderInput}
                    inputStyle={{
                      border: "1px solid #666666",
                      borderRadius: "8px",
                      width: "40px",
                      height: "40px",
                      fontSize: "12px",
                      color: "#000",
                      fontWeight: "400",
                      caretColor: "#666666",
                    }}
                    focusStyle={{
                      outline: "none",
                    }}
                  />
                </div>
                <p className="mb-4 resend-otp">
                  Didn't Received OTP ?{" "}
                  <span
                    className={`${
                      OTPBtnDisabled ? "disabled-link" : "cursor-pointer "
                    } `}
                    onClick={resendOTP}
                  >
                    Resend OTP
                  </span>
                </p>
                <button className="Formbutton">Submit and View API</button>
              </div>
            </form>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}
